// extracted by mini-css-extract-plugin
export default {"wrapper":"service-item_wrapper__14WAB","starsItem":"service-item_starsItem__QHPtP","starsImg":"service-item_starsImg__qpsNx","starsText":"service-item_starsText__3OSzC"};